import React, {useCallback, useContext, useEffect, useState} from 'react';
import {Popup, Input, toast, setOptions, Button} from "@mobiscroll/react";
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import '../styles/dashboardHeaderConversationDuplicate.css';
import {NetworkContext} from "../utils/NetworkContext";
import Empty from "../utils/Empty";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/pro-duotone-svg-icons";

setOptions({
    theme: 'ios',
    themeVariant: 'light',
});

function DashboardHeaderConversationDuplicate({locale, dialog, Dialog, width, archive, setArchive}) {
    const {wsCall, wsResponse, setWsResponse} = useContext(NetworkContext);
    const [label, setLabel] = useState(archive.text);

    const DialogClose = useCallback(() => {
        setArchive({});
        Dialog({view: 'close'});
    }, [Dialog]);

    const ButtonSave = () => {
        if (!label || (label === archive.text)) {
            toast({message: locale.dashboardHeaderConversationDuplicate.c, color: 'danger', display: 'bottom', duration: 3000});
        } else if (label) {

            const message = {
                type: 'wss',
                path: 'archive-duplicate',
                action: 'put',
                data: {
                    conversation: archive.timestamp,
                    text: label
                }
            };
            wsCall(message);
        }
    }

    const PutArchiveDuplicate = useCallback(data => {
        if (data.toast) {
            Dialog({view: 'dashboardHeaderConversations'});
        }
    }, [Dialog]);

    useEffect(() => {
        if (wsResponse && !Empty(wsResponse) && wsResponse.action === 'put' && wsResponse.path === 'archive-duplicate') {
            PutArchiveDuplicate(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, PutArchiveDuplicate, setWsResponse]);

    return (
        <Popup className="cs-dashboard-header-conversation-duplicate-popup" width={600} display="center" scrollLock={true} closeOnOverlayClick={false} closeOnEsc={false} buttons={[]} isOpen={dialog.view === 'dashboardHeaderConversationDuplicate'} onClose={DialogClose}>
            <div className="mbsc-grid cs-dashboard-header-conversation-duplicate-header-col">
                <div className="mbsc-row cs-dashboard-header-conversation-duplicate-header-row">
                    {width > 576 &&
                        <div className="mbsc-col cs-dashboard-header-conversation-duplicate-header-col" />
                    }
                    <div className={width > 576 ? "mbsc-col cs-dashboard-header-conversation-duplicate-header-col mbsc-align-center" : "mbsc-col cs-dashboard-header-conversation-duplicate-header-col"} >
                        <Button className="cs-dashboard-header-conversation-duplicate-title-button mbsc-bold mbsc-txt-muted" variant="flat" >
                            {locale.dashboardHeaderConversationDuplicate.e}
                        </Button>
                    </div>
                    <div className="mbsc-col cs-dashboard-header-conversation-duplicate-header-col mbsc-align-right">
                        <Button color="primary" variant="flat" className="mbsc-bold cs-dashboard-header-conversation-duplicate-close-button" onClick={() => Dialog({view: 'dashboardHeaderConversations'})} >
                            &nbsp;<FontAwesomeIcon className="cs-dashboard-header-conversation-duplicate-close-icon" icon={faXmark} />
                        </Button>
                    </div>
                </div>
            </div>
            <Input inputStyle="underline" label={locale.dashboardHeaderConversationDuplicate.b} labelStyle="floating" type="text" name="account" value={label} onChange={ev => setLabel(ev.target.value)} />
            <div className="mbsc-button-group-justified cs-dashboard-header-conversation-duplicate-nav-buttons">
                <Button color="primary" variant="flat" className="mbsc-bold cs-dashboard-header-conversation-duplicate-nav-button" onClick={() => ButtonSave()} >
                    {locale.dashboardHeaderConversationDuplicate.a}
                </Button>
            </div>
        </Popup>
    );
}

export default DashboardHeaderConversationDuplicate;
